<template>
    <div id="videoPanel">
<!--        <popup ref="popup" type="center" :coverClick="true">-->
            <div class="video_dialog">
                <div class="dialog_close" @click="closeDialog"></div>
                <div class="dialog_body">
                    <div class="video_wrap">
                        <div class="video_main">
                            <video class="video_ele" @pause="videoPause=true" @play="videoPause=false" controls ref="video" :src="videoUrl"></video>
                            <!-- <div class="pause_cover" @click="playVideo" v-show="videoPause">
                                <img class="play_icon" src="./img/video_play.png" alt="">
                                <div class="pause_text">点击观看</div>
                                <div class="cover_text">已经有10万+用户把公文之家添加到电脑桌面，以后点击图标一键打开，无需搜索，非常快捷！</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
<!--        </popup>-->
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "@/components/Popup.vue"
    export default {
        components:{popup},
        data() {
            return {
                tutorialVisible:false,
                videoIndex:0,
                videoUrl:"https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/ad/huihuaxiazaikehuduan.mp4",
                videoPause:true
            }
        },
        created() {
        },
        computed:{
            isLogin(){
                return this.$store.state.isLogin;
            }
        },
        mounted(){
            console.log('执行video')
        },
        methods: {
            show(){
                // this.$refs.popup.show();
                setTimeout(() => {
                    this.$refs.video.play();
                }, 300);
                
            },
            popClose(){
                this.$refs.video.pause();
              console.log(1)
            },
            closeDialog(){
              console.log(2)
                this.$refs.video.pause();
                // this.$refs.popup.close();
                this.$emit('closeVideo')

            },
            playVideo(){
                this.$refs.video.play();
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .video_dialog{
        width: 958px;
        position: relative;
        // padding: 0 20px 20px;
        background-color: #fff;
        border-radius: 5px;
        z-index: 99;
        .dialog_close{
            width: 30px;
            height: 30px;
            border-radius: 15px;
            background-color: #000;
            background-image: url("./img/update_close.png");
            background-size: 16px 16px;
            background-repeat: no-repeat;
            background-position: center;
            position: absolute;
            top: 0;
            right: -46px;
            cursor: pointer;
        }
        .dialog_header{
            padding: 12px 24px;
            border-bottom: 1px solid #ddd;
            box-shadow: 0 10px 10px -5px #e9e9e9;
            .title_text{
                font-size: 24px;
                font-weight: bold;
                line-height: 42px;
            }
            .title_desc{
                display: flex;
                justify-content: space-between;
                line-height: 28px;
                .desc_text{
                    color: #999;
                }
                .play_count{
                    color: #07c160;
                }
            }
        }
        .dialog_body{
            display: flex;
            overflow: hidden;
            .video_wrap{
                flex-shrink: 0;
                // padding: 28px;
                .video_main{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    background-color: #eeeeee;
                    border-radius: 4px;
                    position: relative;
                    .video_ele{
                        // width: 100%;
                        height: 520px;
                        display: block;
                    }
                    .pause_cover{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0, 0, 0, 0.6);
                        cursor: pointer;
                        padding-top: 170px;
                        .play_icon{
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 15px;
                        }
                        .pause_text{
                            text-align: center;
                            font-size: 15px;
                            color: #fff;
                            line-height: 35px;
                        }
                        .cover_text{
                            width: 758px;
                            margin: 90px auto 0;
                            border-radius: 5px;
                            background-color: #000;
                            color: #4d4d4d;
                            line-height: 28px;
                            padding: 16px 22px;
                        }
                    }
                }
            }
        }
    }
</style>